"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Details_1 = __importDefault(require("./Details"));
/**
 * A collection of section details
 * @param {number} count the number of section details returned
 * @param {string} lastKey the pagination key for the last item
 * @param {Array.<Section>} sections the section details
 */
class SectionDetails extends Details_1.default {
    constructor(fields) {
        super(fields, 'sections');
    }
}
exports.default = SectionDetails;
//# sourceMappingURL=SectionDetails.js.map